<app-header></app-header>
<main class="pages">
  <section class="gradient-light">
    <div class="container pt-lg-5">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="h1-title mt-3">Frequently Asked Questions</h1>
          <p class="sub-text mt-3">
            Want to know more about CViewSurvey? Who is an admin or user? Get
            answers to all your frequently asked questions and other such
            queries related to CViewSurvey app.
          </p>
          <div class="mt-lg-5 mt-3">
            <button
              class="btn btn-success btn-lg px-5 text-uppercase"
              type="button"
              data-toggle="modal"
              data-target="#callBack"
              id="callback"
            >
              REQUEST A DEMO
            </button>
          </div>
        </div>
        <div class="col-md-6">
          <div class="page-banner-img">
            <img
              class="img-fluid w-100"
              alt="market Survey"
              src="assets/illustrator/faq.svg"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="py-lg-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <h4 class="font-weight-bold mb-lg-4">FAQ’s for CViewSurvey</h4>
          <ol>
            <li class="font-weight-bold">How does CViewSurvey pricing work?</li>
            <p>
              CViewSurvey is a subscription-based service, which means that your
              plan auto-renews every quarter or year (depending on the term you
              choose). It charges on 3 factors
            </p>
            <ul>
              <li>No. ofUsers/Device License</li>
              <li>Duration (Quartely/Yearly)</li>
              <li>Plan selected</li>
            </ul>
            <p>
              CViewSurvey provides Unlimited Surveys, Unlimited Questions and
              Unlimited Responses to collect in any plan you choose.
            </p>

            <li class="font-weight-bold">
              What is additional User/Device License?
            </li>
            <p>
              Each plan of CViewSurvey comes with license for 1 user/device. If
              you want to assign more than 1 user/device then you will have to
              purchase a user/device license depending on the number of devices
              you want to use CViewSurvey App on.
            </p>

            <li class="font-weight-bold">
              What happens after 7 days Free Trial?
            </li>
            <p>
              Upgrade to a paid plan or contact us before your free trial
              expires to continue using CViewSurvey.
            </p>

            <li class="font-weight-bold">
              Does CViewSurvey support any other Language besides English?
            </li>
            <p>
              We provide you with a multi lingual platform, so that answering
              the surveys can be made comfortable.
            </p>

            <li class="font-weight-bold">
              Can I create a survey from CViewSurvey mobile application?
            </li>
            <p>
              No, you cannot create a survey on CViewSurvey mobile application.
              You can create a survey using PC or Laptop only.
            </p>

            <li class="font-weight-bold">Who is a Company Admin?</li>
            <p>
              A Company Admin is the person who is at some high position in a
              company and will manage all the surveys and users. Generally, a
              Company Admin is a Company Owner or Manager.
            </p>

            <li class="font-weight-bold">Who is a User?</li>
            <p>
              A User is the person whom the Company Admin appoints to go and
              take the surveys. He is the Data Collector/Agent for collecting
              responses on behalf of the company.
            </p>

            <li class="font-weight-bold">Does CViewSurvey work Offline?</li>
            <p>
              Yes, CViewSurvey works both Online & Offline. You can collect data
              anywhere, anytime with or without internet. After you collect data
              offline, when you come into network area, your data will
              automatically be synced to provide real time analysis.
            </p>

            <li class="font-weight-bold">
              Where is the data stored which we collect?
            </li>
            <p>
              All your data is safely stored in Cloud storage. Cloud can store
              unlimited data securely.
            </p>

            <li class="font-weight-bold">Is my payment data safe?</li>
            <p>
              Stripe.com/Paytm powers payments on CViewSurvey. Your card
              information never reaches our servers and is never stored there.
              Stripe is certified to PCI Service Provider Level 1. You may make
              payment via Credit Card, Debit Card or through bank transfer. In
              case you want to make payment against invoice or wire transfer,
              get in touch with sales team at
              <a href="mailto:sales@cviewsurvey.com">sales@cviewsurvey.com</a>
              to get more details.
            </p>

            <li class="font-weight-bold">
              What is refund or cancellation policy?
            </li>
            <p>
              Unfortunately there is no refund or cancellation policy in place.
              In case of outstanding balance you can use that credit towards
              reactivation of your paid subscription in the future. We do not
              offer refunds.For Further details contact:
              <a href="mailto:support@cviewsurvey.com"
                >support@cviewsurvey.com.</a
              >
            </p>

            <li class="font-weight-bold">
              Does CViewSurvey provide White Label Solution?
            </li>
            <p>
              Yes, CViewSurvey provides your Company with White Label solution,
              to personalize your surveys for branding purpose.
            </p>

            <li class="font-weight-bold">
              Is CViewSurvey safe for Businesses?
            </li>
            <p>
              Yes, CViewSurvey is considered to be an absolutely safe and
              trusted site. We respect your privacy concerns and ensure that the
              data is not used for malicious purposes.
            </p>

            <li class="font-weight-bold">
              From where can we download CViewSurvey application?
            </li>
            <p>
              You can download the CViewSurvey Application from Google Play
              Store and iOS App Store.
            </p>

            <li class="font-weight-bold">
              What will happen when the trial expires?
            </li>
            <p>
              You will no longer have access to our features. If in case you
              have created users during your free trial period, they will become
              inactive. You will only get to use them once you upgrade them to
              the pro plan.
            </p>

            <li class="font-weight-bold">Can reports be downloaded?</li>
            <p>Yes, Reports can be downloaded in Excel, CSV and PDF form.</p>

            <li class="font-weight-bold">
              Can reports be downloaded for a particular question?
            </li>
            <p>
              Yes, you can download reports for any question of your choice that
              you want to know the details for.
            </p>
          </ol>
        </div>
      </div>
    </div>
  </section>
</main>
<app-footer></app-footer>
